<template>
  <v-page>
    <div v-if="isLoading" class="d-flex justify-content-center py-4">
      <v-loader />
    </div>

    <template v-else-if="submission">
      <v-link :to="`/me/forms/${formId}/submissions`">
        <toolbar class="mb-3" :logo="false">
          <template v-slot:left>
            <span v-if="submission" class="v-toolbar__text">
              {{ submission.form.title }}
            </span>
          </template>
        </toolbar>
      </v-link>

      <div class="container px-2">
        <form-submission-table
          v-if="submission"
          v-model="submissionValues"
          rounded
          :submission="submission"
          :groups="submission.form_groups"
        />
      </div>
    </template>
  </v-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import EventBus, { EVENTS } from "@/lib/event-bus"

import { toDateTime, timeAgo } from "@/lib/date-utils"

import FormSubmissionTable from "@/components/FormSubmissionTable"
import Toolbar from "@/components/Toolbar"

export default {
  components: {
    FormSubmissionTable,
    Toolbar
  },

  mounted() {
    this.loadSubmission()
  },

  data() {
    return {
      submission: null,
      isLoading: false
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),

    formId() {
      return this.$route.params.formId || this.submission?.form?.id
    },

    submissionId() {
      return this.$route.params.id
    },

    submissionValues: {
      get() {
        return this.submission.values
      },

      set(newValues) {
        this.submission.values = newValues

        this.updateSubmissionValues({
          formId: this.submission.form_id,
          formSubmissionId: this.submission.id,
          values: newValues
        }).then(({ values: savedValues }) => {
          EventBus.$emit(EVENTS.SUBMISSION_VALUES_UPDATED, {
            submissionId: this.submission.id,
            values: savedValues
          })

          for (let fieldId in savedValues) {
            this.$set(this.submission.values, fieldId, savedValues[fieldId])
          }
        })
      }
    }
  },

  methods: {
    toDateTime,
    timeAgo,

    ...mapActions("forms", ["fetchFormSubmission", "updateSubmissionValues"]),

    loadSubmission() {
      if (this.isAuthenticated) {
        this.isLoading = true
        this.fetchFormSubmission({
          formId: this.formId,
          formSubmissionId: this.submissionId
        })
          .then(submission => {
            this.submission = submission
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  },

  watch: {
    isAuthenticated() {
      this.loadSubmission()
    }
  }
}
</script>
